import { render, staticRenderFns } from "./ModalDeletePersonalizationValue.vue?vue&type=template&id=fb6e3c92&scoped=true"
import script from "./ModalDeletePersonalizationValue.vue?vue&type=script&lang=js"
export * from "./ModalDeletePersonalizationValue.vue?vue&type=script&lang=js"
import style0 from "./ModalDeletePersonalizationValue.vue?vue&type=style&index=0&id=fb6e3c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6e3c92",
  null
  
)

export default component.exports